// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3PAyP","search":"Settings_search__2JM8X","filter":"Settings_filter__1Kp_R"};